import { render, staticRenderFns } from "./configuration-automation-protocols-modal-basic-form.vue?vue&type=template&id=795e87bc&scoped=true&"
import script from "./configuration-automation-protocols-modal-basic-form.ts?vue&type=script&lang=ts&"
export * from "./configuration-automation-protocols-modal-basic-form.ts?vue&type=script&lang=ts&"
import style0 from "./configuration-automation-protocols-modal-basic-form.scss?vue&type=style&index=0&id=795e87bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795e87bc",
  null
  
)

export default component.exports